import { UserMenuSchema } from './UserPermissionHelper';
import { AppMenu, AppUserMenu } from '@/api/models';
import { CurrentContract } from '@/api/models/PlayerContractHistory';
import dayjs from 'dayjs';

export interface ITourContractSettings {
  contractEdit: boolean;
  contractHistory: boolean;
}

interface ITourContractItem {
  appMenuId: number;
  name: string;
  uiName: string;
  parentAppMenuId: number;
}

type TourReportsMap = Record<string, ITourContractItem>;

interface IGetTourContractSettingsProps {
  appMenus: AppMenu[];
  userMenus: AppUserMenu[];
  userMenuSchema: UserMenuSchema;
}

export const getTourContractSettings = ({ appMenus, userMenus, userMenuSchema }: IGetTourContractSettingsProps): ITourContractSettings => {
  const tourMenuId = userMenuSchema.Contract.appMenuId;
  //const tourReportsParent = appMenus.find((menu) => menu.name.substring(0, 8) === 'Contract' && menu.parentAppMenuId === tourMenuId);
  //if (!tourReportsParent) throw new Error('Contract parent menu not found');

  const tourReportsMap: TourReportsMap = appMenus
    .filter((menu) => menu.parentAppMenuId === tourMenuId)
    .reduce((acc, menu) => {
      acc[menu.name] = {
        appMenuId: menu.appMenuId,
        name: menu.name,
        uiName: menu.uiName,
        parentAppMenuId: menu.parentAppMenuId!,
      };
      return acc;
    }, {} as TourReportsMap);

  const hasAccess = (reportName: string) => {
    const report = tourReportsMap[reportName];
    return report ? userMenus.some((um) => um.appMenuId === report.appMenuId) : false;
  };

  const tourReportsSettings: ITourContractSettings = {
    contractEdit: hasAccess('ContractEdit'),
    contractHistory: hasAccess('ContractHistory'),
  };

  return tourReportsSettings;
};

export const getContractStatusByDate = (endDate: string) => {
  let status = '';
  if (dayjs(endDate).isValid() && dayjs(endDate).isValid()) {
    if (dayjs(endDate).isValid() && dayjs(endDate).isAfter(new Date())) {
      status = 'active';
    } else {
      status = 'expired';
    }
  }
  return status;
};

export const getContractStatus = (contract?: CurrentContract) => {
  if (!contract || !Object.keys(contract).length) {
    // null or empty object
    return 'no contract';
  } else {
    return contract.status;
  }
};

export const statusColor = (status: string) => {
  let color = '';
  switch (status) {
    case 'active':
      color = 'statusActive';
      break;
    case 'expired':
      color = 'statusExpired';
      break;
    case 'no contract':
      color = 'statusNoContract';
      break;
  }
  return color;
};

export const ContractStatusColor = (contract?: CurrentContract) => {
  let status = getContractStatus(contract);
  return statusColor(status);
};
